/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {KTIcon, useDebounce} from '../../_metronic/helpers'
import {cpfMask} from '../../pages/chooseFranchise/utils/mask'
import {removeSCMask} from '../../utils/formatMonetaryToBr'

interface IDocumentSearch {
  // Valor do filtro aplicado hoje na listagem (state.document)
  currentDocument?: string
  onSearch: (document: string) => void
  inputClassName?: string
}

/**
 * Busca por documento: com "CPF" marcado aplica a máscara e só filtra com os 11 dígitos;
 * desmarcado (passaporte) envia o texto como digitado.
 */
const DocumentSearch = ({
  currentDocument,
  onSearch,
  inputClassName = 'w-200px',
}: IDocumentSearch) => {
  const [isCpf, setIsCpf] = useState<boolean>(true)
  const [searchDocument, setSearchDocument] = useState<string>('')
  const debouncedSearchDocument = useDebounce(searchDocument, 300)

  useEffect(() => {
    const value = debouncedSearchDocument ?? ''
    let document: string
    if (isCpf) {
      const digits = removeSCMask(value)
      document = digits.length === 11 ? digits : ''
    } else {
      document = value.trim()
    }
    if (document !== (currentDocument ?? '')) {
      onSearch(document)
    }
  }, [debouncedSearchDocument])

  const toggleCpf = (checked: boolean) => {
    // Troca de tipo limpa o campo para não enviar CPF com máscara como passaporte (e vice-versa)
    setIsCpf(checked)
    setSearchDocument('')
  }

  return (
    <div className='d-flex align-items-center gap-3'>
      <div className='d-flex align-items-center position-relative'>
        <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
        <input
          type='text'
          data-kt-user-table-filter='document'
          className={`form-control form-control-solid ${inputClassName} ps-14`}
          placeholder={isCpf ? 'Pesquisar CPF' : 'Pesquisar passaporte'}
          value={isCpf ? cpfMask(searchDocument) : searchDocument}
          onChange={(e) => setSearchDocument(e.target.value)}
          maxLength={isCpf ? 14 : 20}
        />
      </div>
      <label className='form-check form-check-sm form-check-custom form-check-solid'>
        <input
          className='form-check-input'
          type='checkbox'
          checked={isCpf}
          onChange={(e) => toggleCpf(e.target.checked)}
        />
        <span className='form-check-label'>CPF</span>
      </label>
    </div>
  )
}

export {DocumentSearch}
